import { Optional } from '@vimeo/core/types/generic';

import { IntegrationLogger } from '../IntegrationLogger';
import type { TIntegrationConfigUnionPartial } from '../shared/integration';

export class ConfigStorageService<Config extends TIntegrationConfigUnionPartial> {
  private static readonly STORAGE_KEY = 'vimeo-integration-sdk-storage';

  private readonly log: IntegrationLogger = IntegrationLogger.create('ConfigStorageService');

  public saveConfig(config: Config): void {
    try {
      sessionStorage.setItem(ConfigStorageService.STORAGE_KEY, JSON.stringify(config));
      this.log.info('config saved to sessionStorage');
    } catch (error) {
      this.log.warn('failed to save config to sessionStorage', error);
    }
  }

  public loadConfig(): Optional<Config> {
    try {
      const stored = sessionStorage.getItem(ConfigStorageService.STORAGE_KEY);
      if (!stored) {
        this.log.info('no data found in sessionStorage');
        return null;
      }
      const configData = JSON.parse(stored) as Config;
      this.log.info('config loaded from sessionStorage');
      return configData;
    } catch (error) {
      this.log.warn('failed to load config from sessionStorage', error);
      return null;
    }
  }

  public clearConfig(): void {
    try {
      sessionStorage.removeItem(ConfigStorageService.STORAGE_KEY);
      this.log.info('config cleared from sessionStorage');
    } catch (error) {
      this.log.warn('failed to clear config from sessionStorage', error);
    }
  }
}
